import React from 'react';

// Last-resort safety net: if anything in the tree throws during render, show a
// friendly "connection issue / retry" card instead of a blank white iframe.
// (Note: this cannot help when the iframe itself fails to load the page -- e.g.
// a VPN/network blocking panda.miamifirstremodeling.com -- because then this
// script never runs. It covers render/runtime errors once the app has loaded.)
type State = { error: Error | null };

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    // Surface to the console so it lands in DevTools + any error tooling.
    console.error('[pandadoc-embed] render error:', error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ display: 'grid', placeItems: 'center', height: '100%', padding: 24, textAlign: 'center' }}>
        <div>
          <strong>Something went wrong loading the PandaDoc panel</strong>
          <p style={{ color: '#6b7280', marginTop: 8, fontSize: 14 }}>
            This is usually a temporary connection hiccup.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 16,
              padding: '8px 18px',
              background: '#2563eb',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }
}
